module.exports = __webpack_public_path__ + "img/TOCTemp2.41d5c98d.png";